<template>
  <div>
    <!-- <meta name="viewport" content="width=device-width,initial-scale=1.0" /> -->
    <sub-head
      subTitle="브랜드 이야기"
      subImg="brandstory_top"
      class="content banner web"
    ></sub-head>
    <sub-head subTitle="브랜드 이야기" class="content banner mobile"></sub-head>

    <div class="page_padding">
      <bread-crumb :path="$route" class=""></bread-crumb>
    </div>
    <div>
      <div class="page_padding">
        <div class="title-background">
          <span class="text">해피테이블과 함께 "100세 까지 총명하게"</span>
        </div>
        <div class="p-relative paddingT text-center">
          <p class="fontBold line-height3 word_break title font34">
            <span class="fontBold textOrange">"100세까지 총명하게"</span>
            <span class="fontBold gray">
              라는 슬로건을 바탕으로 시니어들의 인지력향상에 기여하며
              초고령사회에 재미와 행복을 드리겠습니다.</span
            >
          </p>
        </div>
        <p class="font18 word_break sub-title">
          시니어들의 여가생활증진과 인지력 향상을 위한 종합관리 플랫폼
          <span class="textOrange">"해피테이블"</span> 은 초고령사회의
          시니어들이 느끼는 부족한 사회적 요소를 채워주고 게임을 통해 시니어들의
          흥미를 불러일으켜 건강하게 게임 할 수 있는 환경을 제공합니다.
        </p>
        <div class="brandstory-img">
          <img src="@/assets/source/images/brandstory_info.png" />
        </div>
      </div>
      <div class="bgBackground" style="margin-bottom:1rem">
        <div class="page_padding">
          <span class="logo-text fontBold">해피테이블 로고</span>
          <div class="happytable_logo">
            <img src="@/assets/source/images/brandstory_info02.png" />
          </div>
          <div class="happytable_logo-mobile">
            <img src="@/assets/source/images/brandstory_info02_mobile.png" />
          </div>
          <div class="center-background">
            <span class="center-text"
              >해피테이블의 이미지를 이니셜 H와 테이블 그리고 클로버 잎을 기본
              모티브로 하여 </span
            ><span
              >행복을 상징하는 클로버 잎을 사람으로 형상화하면서 테이블을 둘러싼
              이미지로 표현하였습니다.</span
            >
          </div>
          <div class="logo-img">
            <div class="imgWrap" style="margin-right:1rem">
              <img src="@/assets/source/images/brandstory_logo1.png" />
            </div>
            <div class="imgWrap">
              <img src="@/assets/source/images/brandstory_logo2.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="page_padding">
        <div class="paddingTB">
          <div class="text-center">
            <span class="fontBold vision">비 전</span>
            <p class="fontBold gray sub-title-text font30">
              " 시니어와 가족
              <span class="textOrange fontBold">삶의 질 향상에 기여</span>할 수
              있는 플랫폼 구축 "
            </p>
          </div>
          <p class="font18 word_break sub-title text-left width100">
            글로벌한 인지능력 향상 기술 개발 및 보유 기업으로 성장함과 동시에
            사용자 지향형“ICT융합 인지능력 향상 프로젝트-해피테이블”의 사업화로
            전 세계적으로 건전한 고령화 사회 확립에 기여, 디지털 기반의 “시니어
            여가 활동 증진＂이라는 신 시장을 창출하여 스마트 헬스케어 시장에
            미래 지향형 투자 생태계를 마련함과 동시에 디지털 치료제로의 사업
            방향성으로 나아가겠습니다.
          </p>
          <div class="verticalSpacer-half"></div>
          <!-- <p class="happy-table-text">{{ visionText }}</p> -->
          <div class="verticalSpacer-half"></div>

          <div class="bottom-img page_padding">
            <p class="bottom-img-first padding padding10">
              <img
                src="@/assets/source/images/brandstory/brandstory_img2.png"
              />
              <span class="fontBold font22"
                >이해관계자의 이익을 생각합니다.</span
              >
              <span class="font14"
                >의료진에게는 치매 연구 데이터 제공, 예방 전문가에게는 사용
                편의성과 효율성 제공 당사자 및 보호자에게는 지속적인 상태 자가
                진단 서비스 제공</span
              >
            </p>
            <p class="bottom-img-first  padding10">
              <img
                src="@/assets/source/images/brandstory/brandstory_img3.png"
              />
              <span class="fontBold font22"
                >해피테이블 생태계를 조성하겠습니다.</span
              >
              <span class="font14"
                >치매 관리를 위한 "통합 관리 서비스" 개발 치매 예방을 위한 치매
                예방 콘텐츠 생태계 조성</span
              >
            </p>
            <p class="bottom-img-first  padding10">
              <img
                src="@/assets/source/images/brandstory/brandstory_img4.png"
              />
              <span class="fontBold font22">당신께 힘이 되어드리겠습니다.</span>
              <span class="font14"
                >인지기능 향상과 여가 활동 증진에 기여 다양한 프로그램을 통하여
                협동, 경쟁을 통한 사회성 향상 우울증 감소 및 정서적 안정
                기대</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jsonContents from "../../assets/source/json/sub_top.json";
import cmsContents from "../../assets/source/json/happytable_cms.json";
import htContents from "../../assets/source/json/happytable_info.json";

import BreadCrumb from "../../components/BreadCrumb.vue";
import SubHead from "../../components/sub_head.vue";

export default {
  components: {BreadCrumb, SubHead},
  data() {
    return {
      content: jsonContents,
      ht_info: htContents,
      cms_info: cmsContents,
      is_over: false,
      pic_index: 0,
      showModal: false,
      modalInfo: {
        is_jpg: true,
        name: "",
        path: "",
      },
      frameWidth: "700",
      frameHeight: "395",
      showGame: true,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  created() {
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    getImgSrc(src, path) {
      var images;
      if (path == "") {
        src = "happytable_product" + (src + 2);
        images = require.context(
          "../../assets/source/images/",
          false,
          /\.jpg$/
        );
        return images("./" + src + ".jpg");
      } else if (path == "modal_product") {
        images = require.context(
          "../../assets/source/images/",
          false,
          /\.jpg$/
        );
        return images("./" + src + ".jpg");
      } else {
        images = require.context(
          "../../assets/source/images/screenshots",
          false,
          /\.jpg$/
        );
        return images("./" + src + ".jpg");
      }
    },
    getCMSImgSrc(src) {
      var images = require.context(
        "../../assets/source/images",
        false,
        /\.png$/
      );
      return images("./" + src + ".png");
    },
    is_mouseOver(index) {
      this.pic_index = index;
      this.is_over = true;
    },
    is_mouseDown(index) {
      this.pic_index = index;
      this.is_over = false;
    },
    product_detail(index) {
      this.showModal = true;
      this.modalInfo.name = "happytable_product" + (index + 2);
      document.querySelector("body").style.overflow = "hidden";
      return this.modalInfo;
    },

    closeModal() {
      this.showModal = false;
      document.querySelector("body").style.overflowY = "scroll";
    },
    handleResize() {
      if (matchMedia("(min-width: 1701px)").matches) {
        this.frameWidth = "700";
        this.frameHeight = "395";
      } else if (
        matchMedia("(min-width: 1024px) and (max-width: 1279px)").matches
      ) {
        this.frameWidth = "380";
        this.frameHeight = "220";
      } else if (
        matchMedia("(min-width: 768px) and (max-width: 919px)").matches
      ) {
        this.frameWidth = "250";
        this.frameHeight = "150";
      } else if (
        matchMedia("(min-width: 920px) and (max-width: 1023px)").matches
      ) {
        this.frameWidth = "320";
        this.frameHeight = "190";
      } else if (
        matchMedia("(min-width:1281px) and (max-width:1500px)").matches
      ) {
        this.frameWidth = "500";
        this.frameHeight = "300";
      } else if (
        matchMedia("(min-width:1501px) and (max-width:1700px)").matches
      ) {
        this.frameWidth = "600";
        this.frameHeight = "350";
      }
      if (matchMedia("(max-width:767px)").matches) {
        this.showGame = false;
      } else {
        this.showGame = true;
      }
    },
    show_game() {
      navigator.sayswho = (function() {
        var ua = navigator.userAgent,
          tem,
          M =
            ua.match(
              /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
            ) || [];
        if (/trident/i.test(M[1])) {
          tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
          return "IE " + (tem[1] || "");
        }
        if (M[1] === "Chrome") {
          tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
          if (tem != null)
            return tem
              .slice(1)
              .join(" ")
              .replace("OPR", "Opera");
        }
        M = M[2]
          ? [M[1], M[2]]
          : [navigator.appName, navigator.appVersion, "-?"];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return M.join(" ");
      })();

      if (
        navigator.sayswho == "IE 11" ||
        navigator.sayswho == "MSIE 10" ||
        navigator.sayswho == "MSIE 9" ||
        matchMedia("(max-width: 767px)").matches
      ) {
        this.showGame = false;
      }
      return this.showGame;
    },
  },
};
</script>

<style scoped>
.mobile {
  display: none;
}
.marginTBAuto {
  margin: auto 0;
}
.paddingT {
  padding-top: 100px;
}
.block div.main_product_overlay {
  margin: 1rem;
}
.block div.main_product_overlay.pic2 {
  margin-left: 0;
}
.block div.main_product_overlay:last-child {
  margin-right: 0;
}
.block div img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.block .modal_img img {
  width: 100%;
  height: 100%;
  border-radius: 0px;
}
.d-flex-reverse {
  display: flex;
  flex-direction: row-reverse;
}

.d-flex .right_text {
  padding: 0 3rem;
}
.d-flex-reverse .right_text {
  padding-right: 1rem;
}
.iconWrap {
  width: 150px;
  height: 150px;
}
.iconWrap img {
  width: 50%;
  height: 50%;
}

.cms_content {
  display: flex;
  flex-wrap: wrap;
}
.cms_content .d-flex {
  width: 50%;
}
.banner {
  background-color: #f8f8f8;
}
.top-banner {
  width: 100%;
  padding-top: 71px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.banner-title {
  font-size: 42px;
}
.title {
  /* font-size: 34px; */
  line-height: 1.8;
}

.title-background {
  height: 383px;
  margin-top: 6.2rem;
  background-repeat: no-repeat;
  background-image: url("../../assets/source/images/brandstory/brandstory_img1.png");
}

.title-background .text {
  color: #fff;
  font-size: 30px;
  line-height: 370px;
}
.sub-title {
  color: #5a5a5a;
  font-size: 16px;
  line-height: 1.9;
  width: 90%;
  margin: 0 auto;
  padding-top: 3.8rem;
}

.brandstory-img {
  padding: 6.2rem 0;
}
.bgBackground {
  background: #f7f9fb;
  padding: 10rem 0;
}
.logo-text {
  color: #0a0a0a;
  font-size: 40px;
}
.happytable_logo {
  padding: 6.2rem 0;
}

.center-background {
  background-color: #ffffff;
  padding: 4.6rem 11.5rem;
}

.center-text {
  display: block;
}

.logo-img {
  display: flex;
  justify-content: space-between;
  padding-top: 2rem;
}

.title {
  padding-top: 5rem;
}

.vision {
  margin: 1rem 0;
  font-size: 34px;
}

.text-center .sub-title-text {
  margin-top: 3.6rem;
  word-break: keep-all;
}

.happy-table-text {
  text-align: left;
  color: #5a5a5a;
  line-height: 2;
  font-size: 1.1rem;
}
.font22 {
  font-size: 1.375rem;
  text-align: left;
  margin: 0.5rem 0;
}
.font14 {
  font-size: 1rem;
  color: #5a5a5a;
  text-align: left;
}

.padding10 {
  padding: 1rem;
}
.padding10:first-child {
  padding-left: 0;
}
.padding10:last-child {
  padding-right: 0;
}

.margin10 {
  margin: 2rem 0;
}
.bottom-img {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.bottom-img-first {
  display: flex;
  flex-direction: column;
  width: 500px;
  min-width: 33.3%;
}

/* .happytable_game {
  background-image: url("../../assets/source/images/happytable.png");
  background-repeat: no-repeat;
  padding: 1rem;
} */
.width100 img {
  width: 100%;
  border-radius: 10px;
}
.product_picture {
  /* background-image: url("../../assets/source/images/happytable_bg.jpg");
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat; */
  /* height: 480px; */
  height: 25vw;
}
.overlay_wrap {
  width: 50px;
  height: 50px;
}
.overlay_icon_position {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.overlay_icon_position .overlay_flex {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.overlay_wrap {
  z-index: -1;
}

.is_on .overlay_wrap {
  z-index: 10;
}
.imgWrap img {
  width: 100%;
  height: 100%;
}
.edge {
  position: relative;
}

.iframe-wrapper {
  position: relative;
  background-color: #2b2e35;
  border-radius: 40px;
  padding: 7rem 0;
  width: 100%;
}
.iframe-wrapper .iframe {
  /* position: absolute; */
  width: 100%;
  height: 100%;
}

.imgWrap img {
  width: 100%;
  border-radius: 10px;
}
.experience_logo {
  position: absolute;
  bottom: 40px;
  left: 40px;
  /* width: 80px;
  height: 80px; */
}
.verticalSpacer-big {
  width: 100%;
  height: 10vw;
  margin: 0 auto;
}
.content-padding {
  padding: 3rem 0;
}
.margin_3 {
  margin: 3rem 0;
  padding: 2rem 0;
}
.info_img .imgWrap > img {
  border-radius: 10px !important;
}
.modal_img {
  height: 100%;
}
.modal_img.imgWrap img {
  border-radius: 0px;
  height: 100% !important;
}
.modal_imgWrap.imgWrap {
  height: 100%;
}
.modal_imgWrap.imgWrap img {
  height: 100%;
}
iframe {
  width: 700;
  height: 395;
}

.btn:hover {
  background-color: transparent;
  border-color: white;
}
a {
  text-decoration: none;
}
/* .game_more {
  height: 180px;
  background-image: url("../../assets/source/images/gamemore_bg.jpg");
} */

.happytable_logo-mobile {
  display: none;
}
@media (max-width: 767px) {
  .banner.content.banner.web {
    margin-top: 60px;
    .banner-title {
      line-height: 2.2rem;
    }
  }
  .title-background {
    display: flex;
    padding: 5px;
    .text {
      margin-top: 120px;
      font-size: 2rem;
      line-height: 4rem;
    }
  }
  img {
    max-width: 100%;
  }
  .center-background {
    padding: 0;
  }

  .bottom-img {
    flex-wrap: wrap;
  }

  .font22 {
    font-size: 1.2rem;
  }
}
</style>
